module.exports = __webpack_public_path__ + "static/media/arrow.b3421028.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-carousel-3d/build/img/arrow.png
// module id = 35
// module chunks = 0